module.exports = __webpack_public_path__ + "static/media/samk-logo.f205d816.jpg";